import { render, staticRenderFns } from "./previewComponent.vue?vue&type=template&id=08287ca6&scoped=true"
import script from "./previewComponent.vue?vue&type=script&lang=js"
export * from "./previewComponent.vue?vue&type=script&lang=js"
import style0 from "./previewComponent.vue?vue&type=style&index=0&id=08287ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08287ca6",
  null
  
)

export default component.exports